'use client';

import { useEffect, useRef } from 'react';

import { logSsrDebugEntriesToConsole } from './ssrDebugReplay.utils';
import { ISsrDebugEntry } from './ssrDebugTypes';

export interface ISsrDebugReplayProps {
    entries: ISsrDebugEntry[];
    localStorageKey: string;
    consolePrefix: string;
    isEnvironmentAllowed: boolean;
}

export function SsrDebugReplay({
    entries,
    localStorageKey,
    consolePrefix,
    isEnvironmentAllowed,
}: ISsrDebugReplayProps): null {
    const hasReplayed = useRef(false);

    useEffect(() => {
        if (hasReplayed.current) return;
        hasReplayed.current = true;

        if (!isEnvironmentAllowed || entries.length === 0) return;
        if (localStorage.getItem(localStorageKey) !== 'true') return;

        logSsrDebugEntriesToConsole(entries, consolePrefix);
    }, [entries, localStorageKey, consolePrefix, isEnvironmentAllowed]);

    return null;
}
